import React, { useEffect, useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Modal,
  Box,
  TextField,
  Button,
  Dialog,
} from '@mui/material';
import axios from 'axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';

const Section2 = () => {
  const { t, i18n } = useTranslation();
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: '',
  });

  const isMobile = window.innerWidth < 768;

  const handleOpen = () => {
    setOpen(true);
    setSuccess(false);
  };
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    // Construct the payload
    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      description: formData.description,
      origin: cities.find((city) => city.value === origin)?.label || origin,
      destination:
        cities.find((city) => city.value === destination)?.label || destination,
    };

    try {
      const response = await axios.post(
        'https://hook.us1.make.com/6hxr49p8ex0hgyxuoerytogqp23r3a7s',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        description: '',
      });
      setOrigin('');
      setDestination('');
    } catch (error) {
      console.error('Error submitting the form:', error);
      alert('Une erreur est survenue lors de l’envoi. Veuillez réessayer.');
    }
  };

  const cities = [
    { value: 'mtl', label: 'Montréal' },
    { value: 'laval', label: 'Laval' },
    { value: 'longueuil', label: 'Longueuil' },
    { value: 'repentigny', label: 'Repentigny' },
    { value: 'joliette', label: 'Joliette' },
    { value: 'trois-rivieres', label: 'Trois-Rivières' },
    { value: 'shawinigan', label: 'Shawinigan' },
    { value: 'becancour', label: 'Bécancour' },
    { value: 'victoriaville', label: 'Victoriaville' },
    { value: 'drummondville', label: 'Drummondville' },
    { value: 'thetford-mines', label: 'Thetford Mines' },
    { value: 'levis', label: 'Lévis' },
    { value: 'quebec', label: 'Québec' },
    { value: 'st-hyacinthe', label: 'Saint-Hyacinthe' },
    { value: 'ste-marie', label: 'Sainte-Marie' },
    { value: 'granby', label: 'Granby' },
    { value: 'cowansville', label: 'Cowansville' },
    { value: 'magog', label: 'Magog' },
    { value: 'sherbrooke', label: 'Sherbrooke' },
    { value: 'coaticook', label: 'Coaticook' },
    { value: 'lac-megantic', label: 'Lac-Mégantic' },
    { value: 'saint-georges', label: 'Saint-Georges' },
    { value: 'beauceville', label: 'Beauceville' },
    { value: 'lac-etchemin', label: 'Lac-Etchemin' },
  ];

  return (
    <div
      style={{
        minHeight: '100vh',
        position: 'relative',
      }}
    >
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'white',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          {success ? (
            <div
              style={{
                textAlign: 'center',
                paddingTop: '40px',
                paddingBottom: '40px',
              }}
            >
              <CheckCircleIcon sx={{ fontSize: 60, color: '#04aee7' }} />
              <h5 style={{ marginTop: '10px' }}>
                Votre demande a bien été envoyée !
              </h5>
              <p>
                Vous recevrez une réponse dans les plus brefs délais par
                courriel.
              </p>
              <Button
                sx={{ marginTop: '20px', borderRadius: '30px' }}
                variant="contained"
                color="primary"
                disableElevation
                onClick={handleClose}
              >
                Fermer
              </Button>
            </div>
          ) : (
            <>
              <h2
                id="modal-title"
                className="oxanium"
                style={{ marginBottom: '20px', fontSize: '22px' }}
              >
                {t('deliveryQuote')}{' '}
                <span className="gradient-text-sec">
                  {cities.find((city) => city.value === origin)?.label}
                </span>{' '}
                {t('and')}{' '}
                <span className="gradient-text-sec">
                  {cities.find((city) => city.value === destination)?.label}
                </span>
                .
              </h2>

              <TextField
                fullWidth
                label={t('formName')}
                name="name"
                value={formData.name}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                fullWidth
                label={t('formEmail')}
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                fullWidth
                label={t('formPhone')}
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                fullWidth
                label={t('formDescription')}
                name="description"
                type="text"
                margin="normal"
                multiline
                rows={4}
                value={formData.description}
                onChange={handleChange}
              />

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '20px',
                }}
              >
                <Button
                  sx={{ borderRadius: '30px' }}
                  disableElevation
                  color="grey"
                  variant="outlined"
                  onClick={handleClose}
                >
                  {t('cancel')}
                </Button>
                <Button
                  sx={{
                    borderRadius: '30px',
                    backgroundColor: '#04aee7',
                    fontWeight: 500,
                  }}
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {t('submit')}
                </Button>
              </div>
            </>
          )}
        </Box>
      </Modal>
      <div
        style={{
          background: 'linear-gradient(135deg, #04AEE7 0%, transparent 50%)',
          position: 'absolute',
          height: '100vh',
          top: 0,
          left: 0,
          width: '100%',
          marginLeft: '-500px',
          opacity: 0.5,
        }}
      />
      <div className="container py-5">
        <div
          className="row"
          style={{ position: 'relative', overflow: 'hidden' }}
        >
          <div className="col-md-5 col-12  mt-5" style={{ zIndex: 10 }}>
            <div style={{ maxWidth: '450px' }}>
              <h2 className="text blue oxanium" style={{}}>
                {t('corridorTitle')}
              </h2>
              <div className="d-flex align-items-end" style={{}}>
                <h2 className="super-title blue oxanium">
                  {t('mtlqcCorridor')}
                </h2>
                <h2
                  style={{ marginBottom: '18px', marginLeft: '15px' }}
                  className="text blue oxanium"
                >
                  {t('yulyyzCorridor')}
                </h2>
              </div>
              <div
                style={{
                  position: 'relative',
                  padding: '1px',
                  width: '380px',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(90deg,#04AEE7, transparent)',
                    zIndex: -1,
                    borderRadius: 'inherit',
                  }}
                />
              </div>
              <p className="text mt-3">{t('corridorDescription')}</p>
            </div>
            <div style={{ maxWidth: '450px' }}>
              <h3 style={{ maxWidth: '90%' }} className="section-title mt-5">
                {t('getEstimate')}
              </h3>
              <p className="text mt-1">{t('shortDistanceDelivery')}</p>
              <div
                style={{
                  alignContent: 'center',
                  justifyContent: 'start',
                  display: 'flex',
                  marginTop: '20px',
                  marginBottom: '20px',
                }}
                className="row"
              >
                {/* Origine Dropdown */}
                <div className={!origin ? 'col-6' : 'col-5'}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: '10px' }}
                  >
                    <InputLabel>{t('origin')}</InputLabel>
                    <Select
                      value={origin}
                      onChange={(e) => setOrigin(e.target.value)}
                      label="Origine"
                    >
                      {cities.map((city) => (
                        <MenuItem key={city.value} value={city.value}>
                          {city.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {/* Destination Dropdown */}
                <div className={!destination ? 'col-6' : 'col-5'}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: '10px' }}
                  >
                    <InputLabel>{t('destination')}</InputLabel>
                    <Select
                      value={destination}
                      onChange={(e) => setDestination(e.target.value)}
                      label="Destination"
                    >
                      {cities.map((city) => (
                        <MenuItem key={city.value} value={city.value}>
                          {city.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div style={{ marginTop: '18px' }} className="col-1">
                  <IconButton
                    disabled={!origin || !destination}
                    sx={{ backgroundColor: '#0056A1' }}
                    onClick={handleOpen}
                  >
                    <ArrowForwardIosIcon htmlColor="#FFFFFF" />
                  </IconButton>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7 col-12">
            <div style={{ right: isMobile ? null : 0, zIndex: 1 }}>
              <img
                src="./img/Map.png"
                height={820}
                style={{
                  marginTop: isMobile ? '-440px' : '-200px',
                  marginRight: isMobile ? '' : '-150px',
                  marginLeft: isMobile ? '-100px' : '',
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6 col-12" style={{ paddingRight: '50px' }}>
            <div style={{ border: '2px solid black' }} />
            <div style={{ maxWidth: '450px' }}>
              <h4 style={{ maxWidth: '90%' }} className="section-title mt-5">
                {t('optimizedDesign')}
              </h4>
              <p className="text mt-1">{t('leanTrailerPerformance')}</p>
              <div className="row">
                <div className="col-6">
                  <h3
                    style={{ maxWidth: '90%' }}
                    className="sub-section-title mt-4"
                  >
                    {t('aluminum')}
                  </h3>
                </div>
                <div className="col-6">
                  <h3
                    style={{ maxWidth: '90%' }}
                    className="sub-section-title mt-4"
                  >
                    {t('robustness')}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12" style={{ paddingRight: '50px' }}>
            {' '}
            <div style={{ border: '1px solid black' }} />
            <div style={{ maxWidth: '450px' }}>
              <h4 style={{ maxWidth: '90%' }} className="section-title mt-5">
                {t('customSolution')}
              </h4>
              <p className="text mt-1">{t('leanTrailerFeatures')}</p>
              <div className="row">
                <div className="col-6">
                  <h3
                    style={{ maxWidth: '90%' }}
                    className="sub-section-title mt-4"
                  >
                    {t('fullyElectric')}
                  </h3>
                </div>
                <div className="col-6">
                  <h3
                    style={{ maxWidth: '90%' }}
                    className="sub-section-title mt-4"
                  >
                    {t('flexible')}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
